import { Amount } from '@/types/amount';
import { Locale } from '@/types/locale';
import { toValidCurrency } from '@/utility/currencies';
import { getCurrencySymbol } from '@/utility/formatAmount';
import { numbersLocale } from '@/utility/numbersLocale';

const STABLECOIN_CODES = new Set(['USDC', 'USDT', 'MXNB', 'BRL1']);

const format = (locale: Locale, amount: Amount): string => {
  // For USD and stablecoins, use custom formatting that surfaces the actual code
  // and avoids Intl.NumberFormat rejecting non-ISO codes like USDC, MXNB, BRL1.
  if (amount.currencyCode === 'USD' || STABLECOIN_CODES.has(amount.currencyCode)) {
    const numberFormatter = new Intl.NumberFormat(numbersLocale(locale), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const formattedNumber = numberFormatter.format(amount.value ?? 0);
    const symbol = getCurrencySymbol(locale, amount.currencyCode);
    return `${symbol}${formattedNumber} ${amount.currencyCode}`;
  }

  // For other currencies, use standard formatting
  const formatter = new Intl.NumberFormat(numbersLocale(locale), {
    style: 'currency',
    currency: toValidCurrency(amount.currencyCode),
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount.value ?? 0);
};

export const transactionFromToAmount = (locale: Locale, from: Amount, to: Amount): string =>
  `${format(locale, from)} \u2192 ${format(locale, to)}`;
